import type { ReactNode } from 'react';
import { memo } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

interface LinkCellProps {
  to: string;
  children: ReactNode;
}

const LinkCell = ({ to, children }: LinkCellProps) => {
  return (
    <StyledNavLink
      to={to}
      onClick={(event) => event.stopPropagation()} // Prevent usual row click
    >
      {children}
    </StyledNavLink>
  );
};

export default memo(LinkCell);

const StyledNavLink = styled(NavLink)`
  // Remove usual link styling
  color: inherit;
  text-decoration: none;
`;
